import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import {inviteMember as inviteMemberApi} from 'services/company/api';
import {handleValueChange} from 'utils/ComponentUtilFunctions';
import Translate from 'components/Translate';
import TranslateProperty from 'components/TranslateProperty';
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import Input from "../../../../../components-new/form/Input";
import DropdownSelect from "../../../../../components-new/form/DropdownSelect";

class InviteMember extends React.Component {
    constructor(props) {
        super(props);
        const {roles} = config;
        this.state = {
            role: roles[0] ? roles[0] : {},
            email: '',
            inviting: false,
        };
        this.handleChange = handleValueChange.bind(this);
    }


    componentDidMount() {
        const {role} = this.state;
        const {roles} = config;

        if (!role && roles[0]) {
            this.setState({
                role: roles[0].value,
            });
        }
    }

    getApiDataFromState() {
        const {role, email} = this.state;
        const subCompanyIds = [];
        return {
            role: role.value,
            email,
            subCompanyIds,
        };
    }

    invite = () => {
        const {inviting} = this.state;

        if (inviting) {
            return;
        }

        const {addNotification} = this.props;


        this.setState({
            inviting: true,
        });

        inviteMemberApi(this.getApiDataFromState())
            .then(() => {
                addNotification('memberInvited');
                this.props.fetchCompany();
                this.setState({email: ""});
            })
            .catch((e) => {
                /* named by the server, looked up in the locales - see Employees */
                const reason = e.response && e.response.data;
                addNotification(reason || 'somethingWentWrong', config.notificationLevels.error);
            })
            .finally(() => {
                this.setState({
                    inviting: false,
                });
            });
    };

    render = () => {
        const {
            email, role, inviting,
        } = this.state;

        let roles = config.roles.filter((c) => c.id !== config.rolesMap.owner);

        if (!role && roles[0]) {
            this.setState({
                role: roles[0].value,
            });
        }

        const {user} = this.props;

        if (user.authorities[0] === config.rolesMap.admin) {
            roles = roles.filter(it => it.name !== 'OWNER')
        }

        return (
            <div className="invite-member-form">
                <TranslateProperty properties={[{key: 'placeholder', value: 'email*'}]}>
                    <Input controlled onChange={(e) => this.handleChange('email')(e.target.value)} value={email}/>
                </TranslateProperty>
                <DropdownSelect
                    options={roles}
                    selectedValue={role}
                    onChange={this.handleChange('role')}
                    variant="outline"
                    renderLabel={(val) => val.title}
                    styles={{color: 'var(--ds-text-primary)', width: '100%'}}
                >
                    {(option) => option.title}
                </DropdownSelect>
                <BlueButton
                    type="button"
                    width="120px"
                    height="36px"
                    disabled={inviting}
                    children={<Translate text="invite"/>}
                    onClick={this.invite}
                />
            </div>
        );
    };
}

InviteMember.propTypes = {
    addNotification: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    fetchCompany: PropTypes.func.isRequired
};


export default InviteMember;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/InviteMember.jsx